"use client";
import Script from "next/script";

const AudioEyeScript = () => {
    const audioEyeId = process.env.NEXT_PUBLIC_AUDIOEYE_ID;
    if (!audioEyeId || audioEyeId.toLowerCase() === "false") {
        return null;
    }
    // Enable AudioEye for PR.
    return (
        <>
            <Script
                id="audioeye-sitehash"
                strategy="beforeInteractive"
            >{`window.__AudioEyeSiteHash = "${audioEyeId}";
(function() {
  var origAssign = Object.assign;
  Object.assign = function(target) {
    var result = origAssign.apply(this, arguments);
    if (result && result.productConfig && result.productConfig.launcher && result.productConfig.launcher["opt-in"] === false) {
      result.productConfig.launcher["opt-in"] = true;
      Object.assign = origAssign;
    }
    return result;
  };
  var initInterval = setInterval(function() {
    if (window.AudioEye && window.AudioEye.ClientElementApi && window.AudioEye.ClientElementApi.init && document.getElementById("audioeye_activate_btn")) {
      clearInterval(initInterval);
      try {
        window.AudioEye.ClientElementApi.init();
        document.getElementById("audioeye_activate_btn").removeAttribute("disabled");
      } catch(e) {}
    }
  }, 100);
})();`}</Script>
            <Script
                id="audioeye-loader"
                src="https://wsmcdn.audioeye.com/aem.js"
                strategy="lazyOnload"
            />
        </>
    );
};

export default AudioEyeScript;
